"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputSize = exports.InputVariation = void 0;
var InputAutoSize_1 = __importDefault(require("./InputAutoSize"));
var InputVariation;
(function (InputVariation) {
    InputVariation["Large"] = "large";
    InputVariation["Pencil"] = "pencil";
})(InputVariation = exports.InputVariation || (exports.InputVariation = {}));
var InputSize;
(function (InputSize) {
    InputSize["Auto"] = "auto";
})(InputSize = exports.InputSize || (exports.InputSize = {}));
exports.default = (function (createUi, noop, utils, invoke) {
    return function (options) {
        options.type = options.type || "text";
        options.label = options.label || options.name;
        options.onChange = options.onChange || noop;
        options.onClick = options.onClick || noop;
        options.id = utils.randomString();
        if (options.variation === InputVariation.Large) {
            return createUi(require("./InputLarge.html"), options);
        }
        else if (options.variation === InputVariation.Pencil) {
            return createUi(require("./InputPencil.html"), options);
        }
        else if (options.size === "auto") {
            return new (invoke(InputAutoSize_1.default))(options.className, options.value, options.onChange);
        }
        else {
            return createUi(require("./Input.html"), options);
        }
    };
});
